module.exports = __webpack_public_path__ + "img/three1Blue.479a013d.jpg";